<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  beforeDestroy() {
    sessionStorage.clear();
    localStorage.clear();
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue